import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'

const CustomDialog = withStyles({
  paper: {
    width: '100%',
    borderRadius: 2
  }
})(Dialog)

export default CustomDialog
